import { createActions } from 'redux-actions';

export default createActions(
  {
    SET: (key, value) => ({ key, value }),
    RESET: () => ({}),
  },
  { prefix: 'QUERY' }
);
